import withWrappers from 'hocs/ReactKeyProvider';
import PDP from './PDP';

export default withWrappers(PDP);
